
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class SetItemsEditor extends Common.GridEditorBase<SetItemsRow> {
        protected getColumnsKey() { return 'Inventory.SetItems'; }
        protected getDialogType() { return SetItemsDialog; }
        protected getLocalTextPrefix() { return SetItemsRow.localTextPrefix; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = Common.StockSelectGrid;

            buttons.push({
                title: "Add Products",
                cssClass: "add-button",
                hotkey: "Alt + K",
                onClick: () => {

                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: true,
                        preSelectedKeys: this.value.map(k => k.ProductId)
                    });

                    pickerDialog.onSuccess = (selectedItems: any[]) => {
                        let selectedItems2 = selectedItems.filter(t => { return !Q.any(this.view.getItems(), n => n.ProductId == t.ProductId) });
                        var self = this;
                        var Items = [];

                        selectedItems2.forEach(function (value) {
                            var PrdId = value.ProductId;
                            var AtbId = value.AttributeId;
                            var PrdDetails = value;
                            var SetItem: SetItemsRow = {
                                ProductId: PrdId,
                                ProductCode: PrdDetails.ProductCode,
                                AttributeId: AtbId,
                                Line_No: value.LineNo,
                                StockId: value.StockId,
                                SKU: value.SKU

                            };
                            Items.push(SetItem);

                        });

                        for (let Item of Items) {
                            Item[this.getIdProperty()] = "`" + this.nextId++;
                            var x = Item;
                            this.view.addItem(Item);
                            this.view.refresh();
                        }

                    }
                    pickerDialog.dialogOpen();
                }
            });

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            return buttons;
        }

        validateEntity(row: SetItemsRow, id: number) {
            if (!super.validateEntity(row, id))
                return false;

            row.ProductId = Q.toId(row.ProductId);

            var sameProduct = Q.tryFirst(this.view.getItems(), x => x.ProductId === row.ProductId);
            if (sameProduct && this.id(sameProduct) !== id) {
                Q.alert('This Product is already added!');
                return false;
            }
            row.ProductCode ;
            return true;
        } 
    }
}